import { Field } from 'formik';

import * as S from './styles';

export type RadioProps = {
  name: string;
  value: string;
  text?: string;
  variant?: 'primary' | 'secondary' | 'third';
  icon?: React.ReactNode;
};

const Radio = ({
  name,
  value,
  variant = 'primary',
  text = value,
  icon,
}: RadioProps) => (
  <S.Label variant={variant}>
    <Field name={name} type="radio" value={value} />
    <div>
      {variant === 'third' && !!icon && icon}
      <span>{text}</span>
    </div>
  </S.Label>
);

export default Radio;
